import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject, throwError } from "rxjs";
import { catchError, shareReplay } from "rxjs/operators";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class CoursesService {
  baseUrl: string;

  courses: any[] = [
    {
      name: "FAR",
      icon: "far-icon.svg",
      core: "Core",
      sub_id: 103,
    },
    {
      name: "AUD",
      icon: "aud-icon.svg",
      core: "Core",
      sub_id: 101,
    },
    { name: "REG", icon: "reg-icon.svg", core: "Core", sub_id: 104 },
    { name: "TCP", icon: "tcp-icon-new.svg", core: "Discipline", sub_id: 111 },
    {
      name: "BAR",
      icon: "bar-icon.svg",
      core: "Discipline",
      sub_id: 110,
    },
    {
      name: "ISC",
      icon: "isc-icon-new.svg",
      core: "Discipline",
      sub_id: 112,
    },
  ];

  disciplineSwap: BehaviorSubject<any> = new BehaviorSubject({});
  disciplineSwap$ = this.disciplineSwap.asObservable();
  private isSubjectExpiryForStudyPlanner = new Subject<boolean>();
  message$ = this.isSubjectExpiryForStudyPlanner.asObservable();
  private updatedExamDate = new Subject<string>();
  updatedDate$ = this.updatedExamDate.asObservable();

  private subjectDetails$: Observable<any>;
  private studyPlanner$: Observable<any>;

  constructor(private _http: HttpClient) {
    this.baseUrl = environment.apiUrl;
  }

  /* Subject Swap data */
  setSwapModal(data: any) {
    this.disciplineSwap.next(data);
  }

  /* subject expiery for Study Planner */
  subjectExpiryStatusSendMessage(message: boolean) {
    this.isSubjectExpiryForStudyPlanner.next(message);
  }

  /* Get progress color */
  getProgressColors() {
    return this._http.get<any>("assets/courses/progressColor.json");
  }

  /* Getting the dashboard data */
  getDashboardData(data: any): Observable<any> {
    return this._http
      .post<any>(`${this.baseUrl}dashboard`, data)
      .pipe(catchError(this.handleError));
  }

  /* Getting the Subject data */
  getSubjectDetails(): Observable<any> {
    if (!this.subjectDetails$) {
      this.subjectDetails$ = this._http
        .post<any>(`${this.baseUrl}subjectDetails`, {})
        .pipe(shareReplay(1), catchError(this.handleError));
    }
    return this.subjectDetails$;
  }

  /* Getting the weekly activity */
  getDashActivity(subjectId: string): Observable<any> {
    return this._http
      .get<any>(`${this.baseUrl}dashboard/activity/${subjectId}`)
      .pipe(catchError(this.handleError));
  }

  /* Get Study Planner Week and Overall */
  getStudyPlanner(
    subjectId: string,
    type: string,
    forceRefresh: boolean = false
  ): Observable<any> {
    if (!this.studyPlanner$ || forceRefresh) {
      this.studyPlanner$ = this._http
        .get<any>(`${this.baseUrl}sp/${subjectId}?type=${type}`)
        .pipe(shareReplay(1), catchError(this.handleError));
    }
    return this.studyPlanner$;
  }

  /* Get Study Planner */
  getEnableStudy(subjectId: string): Observable<any> {
    return this._http
      .get<any>(`${this.baseUrl}sp/enable/${subjectId}`)
      .pipe(catchError(this.handleError));
  }
  getStudyPlannerSummary(subjectId: string): Observable<any> {
    return this._http
      .get<any>(`${this.baseUrl}sp/summary/${subjectId}`)
      .pipe(catchError(this.handleError));
  }

  /* Create study planner */
  createStudyPlanner(data: any): Observable<any> {
    return this._http
      .post(`${this.baseUrl}sp/create`, data)
      .pipe(catchError(this.handleError));
  }

  /* Create study planner */
  enableDisciplineOptions(data: any): Observable<any> {
    return this._http
      .post(`${this.baseUrl}activateDisciplineSubjects`, data)
      .pipe(catchError(this.handleError));
  }

  /* Activate disciplinary subject */
  activeDisciplineSub(data: any): Observable<any> {
    return this._http
      .post(`${this.baseUrl}confirmDisciplineSubject`, data)
      .pipe(catchError(this.handleError));
  }

  /* Update study planner */
  // updateStudyPlanner(subjectId: string, data: any): Observable<any> {
  //   return this._http
  //     .post(
  //       `${this.baseUrl}sp/update/${subjectId}?type=${data.type}&setting=${data.setting}`,
  //       {
  //         from_date: data.from_date,
  //         week_hrs: data.week_hrs,
  //       }
  //     )
  //     .pipe(catchError(this.handleError));
  // }
  updateStudyPlanner(subjectId: string, data: any): Observable<any> {
    return this._http
      .post(
        `${this.baseUrl}sp/update/${subjectId}?type=${data.type}&setting=${data.setting}`,
        {}
      )
      .pipe(catchError(this.handleError));
  }

  /* Handling errors */
  private handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error("An error occurred:", error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, body was: `,
        error.error
      );
    }
    // Return an observable with a user-facing error message.
    return throwError(
      () => new Error("Something bad happened; please try again later.")
    );
  }
  // Getting batches for this subject
  getsubjectbasedbatches(data: any): Observable<any> {
    return this._http
      .post<any>(`${this.baseUrl}admin/webinar/getsubjectbasedbatches`, data)
      .pipe(catchError(this.handleError));
  }

  // Getting batches for this subject
  zoomListLmsWebinar(data: any): Observable<any> {
    return this._http
      .post<any>(`${this.baseUrl}admin/webinar/zoomListLmsWebinar`, data)
      .pipe(catchError(this.handleError));
  }

  getProgressGraph(progress: any) {
    let progressdata: any = {};
    let rawSVG25 = `<circle cx="94.5782" cy="131.1583" r="4.97664" fill="#3499FF"></circle>
          <circle cx="94.5782" cy="131.1583" r="2.48832" fill="white"></circle>
          <g transform="translate(94, 119)">
             <line x1="0" y1="8" x2="0" y2="-10" class="flagpole"></line>
          <path d="M0 -10 C6 -8, 10 -3, 15 -6 C7 1, 5 -2, 0 -2 Z" fill="#098ff1" stroke="#098ff1" stroke-width="0.9"/>
          </g>`;
    let rawSVGLessThan25 = `<circle cx="94.5782" cy="131.1583" r="4.97664" fill="#3499FF"></circle>
          <circle cx="94.5782" cy="131.1583" r="2.48832" fill="white"></circle>`;

    let rawSVGLessThan15 = `<circle cx="68.5782" cy="149.1583" r="4.97664" fill="#3499FF"></circle>
                      <circle cx="68.5782" cy="149.1583" r="2.48832" fill="white"></circle>`;

    let rawSVG50 = `<circle cx="158" cy="122" r="4.97664" fill="#3499FF"></circle>
          <circle cx="158" cy="122" r="2.48832" fill="white"></circle>
          <g transform="translate(158, 112)">
              <line x1="0" y1="8" x2="0" y2="-10" class="flagpole"></line>
          <path d="M0 -10 C6 -8, 10 -3, 15 -6 C7 1, 5 -2, 0 -2 Z" fill="#098ff1" stroke="#098ff1" stroke-width="0.9"/>
          </g> `;
    let rawSVG75 = `<circle cx="115" cy="85" r="4.97664" fill="#3499FF"></circle>
          <circle cx="115" cy="85" r="2.48832" fill="white"></circle>
         <g transform="translate(115, 75)">
          <line x1="0" y1="8" x2="0" y2="-10" class="flagpole"></line>
          <path d="M0 -10 C6 -8, 10 -3, 15 -6 C7 1, 5 -2, 0 -2 Z" fill="#098ff1" stroke="#098ff1" stroke-width="0.9"/>
        </g>`;

    let rawSVG100 = `<circle cx="99.5782" cy="34.1583" r="4.97664" fill="#3499FF"></circle>
            <circle cx="99.5782" cy="34.1583" r="2.48832" fill="white"></circle>
            <g transform="translate(100, 24)">
                <line x1="0" y1="8" x2="0" y2="-10" class="flagpole"></line>
          <path d="M0 -10 C6 -8, 10 -3, 15 -6 C7 1, 5 -2, 0 -2 Z" fill="#4caf50" stroke="#4caf50" stroke-width="0.9"/>
            </g>`;
    let path25 = `M72.5769 151.237 C54.952 144.498 36.0394 132.367 90.7824 131.538`;
    let path50 = `M72.5769 151.237C54.952 144.498 36.0394 132.367 90.7824 131.538C145.525 130.708 159.211 126.008 159.211 123.762`;
    let path75 = `M72.5769 151.237 C54.952 144.498 36.0394 132.367 90.7824 131.538C145.525 130.708 159.211 126.008 159.211 123.762C161.284 122.034 160.531 117.914 141.525 111.32`;
    let path80 = `M72.5769 151.237 C54.952 144.498 36.0394 132.367 90.7824 131.538C145.525 130.708 159.211 126.008 159.211 123.762C161.284 122.034 160.531 117.914 141.525 111.32C117.618 103.026 101.09 89.8167 112.037 87.9922`;
    let path90 = `M72.5769 151.237 C54.952 144.498 36.0394 132.367 90.7824 131.538C145.525 130.708 159.211 126.008 159.211 123.762C161.284 122.034 160.531 117.914 141.525 111.32C117.618 103.026 101.09 89.8167 112.037 87.9922C124.478 85.9186 141.525 85.4002 127.01 76.069`;
    let path100 = `M72.5769 151.237C54.952 144.498 36.0394 132.367 90.7824 131.538C145.525 130.708 159.211 126.008 159.211 123.762C161.284 122.034 160.531 117.914 141.525 111.32C117.618 103.026 101.09 89.8167 112.037 87.9922C124.478 85.9186 141.525 85.4002 127.01 76.069C112.494 66.7378 95.3873 51.7042 99.0161 32.5234`;
    // <g transform="translate(115, 75)">
    // <line x1="0" y1="11" x2="0" y2="-15" class="flagpole"></line>
    // <path d="M0 -15 C10 -12, 16 -4, 25 -10 C11 2, 8 -3, 0 -3 Z" fill="lightblue" stroke="lightblue" stroke-width="1"/>
    // </g>
    // console.log(progress, "progress");
    switch (true) {
      case (progress > 0 && progress < 15) || progress == 0 || progress == null:
        return (progressdata = {
          progressPath: "",
          pathFlag: rawSVGLessThan15,
        });
      case progress >= 15 && progress < 25:
        return (progressdata = {
          progressPath: path25,
          pathFlag: rawSVGLessThan25,
        });
      case progress == 25:
        return (progressdata = { progressPath: path25, pathFlag: rawSVG25 });

      case progress > 25 && progress < 50:
        return (progressdata = { progressPath: path50, pathFlag: rawSVG25 });
      case progress == 50:
        return (progressdata = { progressPath: path50, pathFlag: rawSVG50 });

      case progress > 50 && progress < 75:
        return (progressdata = { progressPath: path75, pathFlag: rawSVG50 });
      case progress == 75:
        return (progressdata = { progressPath: path80, pathFlag: rawSVG75 });

      case progress > 75 && progress < 80:
        return (progressdata = { progressPath: path80, pathFlag: rawSVG75 });
      case progress == 80:
        return (progressdata = { progressPath: path80, pathFlag: rawSVG75 });

      case (progress > 80 && progress <= 90) ||
        (progress > 90 && progress < 100):
        return (progressdata = { progressPath: path90, pathFlag: rawSVG75 });
      case progress == 100:
        return (progressdata = { progressPath: path100, pathFlag: rawSVG100 });
      default:
        return (progressdata = {
          progressPath: "",
          pathFlag: rawSVGLessThan25,
        });
    }
  }

  /* Enable Study Planner */
  enableStudyplanner(subjectId: any, data: any): Observable<any> {
    // const param: any = {
    //   subject: subjectId,
    //   data: data,
    // };
    // return param;
    return this._http
      .post<any>(`${this.baseUrl}sp/enable/${subjectId}`, data)
      .pipe(catchError(this.handleError));
  }

  updateExamDate(data: any): Observable<any> {
    return this._http
      .post(`${this.baseUrl}update-scheduled-exam-date`, data)
      .pipe(catchError(this.handleError));
  }

  sendUpdateExamDate(updatedDate: string) {
    this.updatedExamDate.next(updatedDate);
  }

  sendRequest(data: any) {
    return this._http
      .post<any>(`${this.baseUrl}courseAccessRequest`, data)
      .pipe(catchError(this.handleError));
  }
}
